import { useState } from "react";
import styled from "styled-components";
import Reveal from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { Container, Section, Eyebrow } from "../components/ui";
import config from "../config";

const groups = [
  {
    title: "Produkti",
    items: [
      {
        q: "Çfarë është saktësisht Aroma Stick?",
        a: "Është një inhalator i vogël me vajra esencialë organikë. E hap, merr dy ose tre frymëmarrje nga hunda, dhe e mbyll. Nuk prek lëkurën, nuk pihet dhe nuk ka nevojë për pajisje tjetër.",
      },
      {
        q: "Sa zgjat një inhalator?",
        a: "Deri në gjashtë muaj me përdorim të rregullt. Kjo varet nga sa shpesh e përdor, por shumica e klientëve na thonë që u zgjat gjysmë viti ose më shumë.",
      },
      {
        q: "A janë vërtet 100% organike?",
        a: "Po. Vajrat esencialë janë të certifikuar organikë dhe përzierjet prodhohen në një laborator në Zvicër. Nuk përmbajnë aroma sintetike apo mbushës.",
      },
      {
        q: "Cili variant më duhet mua?",
        a: "Varet nga problemi. Sleep për gjumin, Focus për përqendrim, Energy për rënie energjie, Calm dhe Relax për stres, Breathe për ndjesi freskie, Nausea për udhëtime, Slim për momentet e dëshirës për ushqim. Nëse nuk je i sigurt, na shkruaj dhe të ndihmojmë.",
      },
    ],
  },
  {
    title: "Përdorimi dhe siguria",
    items: [
      {
        q: "A mund ta përdorin fëmijët?",
        a: "Shumica e varianteve janë të përshtatshme për fëmijë mbi 6 vjeç. Breathe nuk e rekomandojmë për fëmijë, sepse eukalipti dhe nenexhiku janë aroma të forta. Për fëmijë nën 6 vjeç, konsultohu me mjekun.",
      },
      {
        q: "A mund ta përdor gjatë shtatzënisë?",
        a: "Konsultohu paraprakisht me mjekun tënd. Disa vajra esencialë nuk rekomandohen gjatë shtatzënisë.",
      },
      {
        q: "A krijon varësi ose ka efekte anësore?",
        a: "Nuk përmban ilaçe dhe nuk krijon varësi. Si çdo produkt me vajra esencialë, disa persona mund të jenë të ndjeshëm ndaj aromave të caktuara. Nëse ndien parehati, ndërpre përdorimin.",
      },
      {
        q: "A e zëvendëson ilaçin tim?",
        a: "Jo. Aroma Stick është produkt aromaterapie, jo ilaç, dhe nuk zëvendëson këshillën apo trajtimin mjekësor. Mos ndërpre asnjë terapi pa folur me mjekun.",
      },
    ],
  },
  {
    title: "Porosia dhe transporti",
    items: [
      {
        q: "Si bëj porosi?",
        a: "Na shkruaj në WhatsApp ose në Instagram, na thuaj cilin variant do dhe adresën, dhe e dërgojmë.",
      },
      {
        q: "Sa kushton dhe a paguaj transport?",
        a: `Çmimi është ${config.price} për inhalator dhe transporti është falas. Gjithashtu, ${config.bundle.toLowerCase()}.`,
      },
      {
        q: "Sa zgjat dërgesa?",
        a: "Zakonisht brenda një deri në tri ditë pune brenda Kosovës.",
      },
      {
        q: "A mund të porosis disa variante bashkë?",
        a: `Po, dhe kjo është mënyra më e volitshme. ${config.bundle} — shumë klientë marrin Sleep, Focus dhe Calm bashkë.`,
      },
    ],
  },
];

export default function Faq() {
  const [open, setOpen] = useState("0-0");

  return (
    <>
      <Top>
        <Container>
          <Reveal>
            <Eyebrow>Pyetje</Eyebrow>
            <H1>Gjithçka që na pyesin më shpesh</H1>
          </Reveal>
        </Container>
      </Top>

      <Section $tight>
        <Container $narrow>
          {groups.map((g, gi) => (
            <Group key={g.title}>
              <Reveal>
                <GroupTitle>{g.title}</GroupTitle>
              </Reveal>
              <Reveal delay={0.05}>
                <List>
                  {g.items.map((it, ii) => {
                    const id = `${gi}-${ii}`;
                    const isOpen = open === id;
                    return (
                      <Item key={it.q}>
                        <Btn
                          onClick={() => setOpen(isOpen ? null : id)}
                          aria-expanded={isOpen}
                        >
                          <span>{it.q}</span>
                          <Sign $open={isOpen}>+</Sign>
                        </Btn>
                        <Body $open={isOpen}>
                          <p>{it.a}</p>
                        </Body>
                      </Item>
                    );
                  })}
                </List>
              </Reveal>
            </Group>
          ))}
        </Container>
      </Section>

      <Spacer />
      <CTABanner />
    </>
  );
}

const Top = styled.header`
  padding: 148px 0 0;
  ${({ theme }) => theme.bp.md} {
    padding: 190px 0 0;
  }
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.size.h1};
  max-width: 16ch;
`;

const Group = styled.div`
  margin-bottom: 56px;
`;

const GroupTitle = styled.h2`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.size.xs};
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.inkFaint};
  margin-bottom: 14px;
`;

const List = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.line};
`;

const Item = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
`;

const Btn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  padding: 22px 0;
  text-align: left;
  font-size: ${({ theme }) => theme.size.lg};
  font-family: ${({ theme }) => theme.font.display};
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }
`;

const Sign = styled.span`
  flex-shrink: 0;
  font-size: 1.5rem;
  line-height: 1;
  color: ${({ theme }) => theme.colors.brand};
  transition: transform 0.4s ${({ theme }) => theme.ease};
  transform: rotate(${({ $open }) => ($open ? "135deg" : "0deg")});
`;

const Body = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  transition: grid-template-rows 0.45s ${({ theme }) => theme.ease};

  p {
    overflow: hidden;
    color: ${({ theme }) => theme.colors.inkSoft};
    max-width: 62ch;
    padding-bottom: ${({ $open }) => ($open ? "24px" : "0")};
    transition: padding 0.45s ${({ theme }) => theme.ease};
  }
`;

const Spacer = styled.div`
  height: 40px;
  ${({ theme }) => theme.bp.md} {
    height: 80px;
  }
`;
